const HERO_MQ = '(min-width: 768px)'
const HIDE_LOOK_PX = 250
const SHOW_BACK_PX = 50
const HERO_RIGHT_TAIL_PX_DEFAULT = 120

/** Порог прокрутки hero по X: после — снять блюр / включить слайды в макбуке */
export const HERO_MBP_REVEAL_PX = 40

export function initHeroStudioScroll() {
  const root = document.querySelector('[data-hero-studio]')
  if (!root) {
    return
  }

  const scroller = root.querySelector('.hero-studio__scroll')
  if (!scroller) {
    return
  }
  const figure = root.querySelector('.hero-studio__figure')

  const mq = window.matchMedia(HERO_MQ)
  let abort = new AbortController()

  const getRightTailPx = () => {
    const cssValue = window.getComputedStyle(root).getPropertyValue('--hero-scroll-right-tail-px')
    const parsed = Number.parseFloat(cssValue)
    return Number.isFinite(parsed) ? Math.max(0, parsed) : HERO_RIGHT_TAIL_PX_DEFAULT
  }

  const getMaxScroll = () => {
    const nativeMax = Math.max(0, scroller.scrollWidth - scroller.clientWidth)
    if (!figure) {
      return nativeMax
    }

    const scRect = scroller.getBoundingClientRect()
    const figRect = figure.getBoundingClientRect()
    const figureRightInContent = scroller.scrollLeft + (figRect.right - scRect.left)
    const figureBoundMax = Math.max(
      0,
      figureRightInContent - scroller.clientWidth + getRightTailPx(),
    )

    return Math.min(nativeMax, figureBoundMax)
  }

  const clearInlines = () => {
    root
      .querySelectorAll('[data-hero-scroll], [data-hero-scroll-hide-at-max]')
      .forEach((el) => {
        el.style.opacity = ''
        el.style.pointerEvents = ''
      })
  }

  const dispatchMbp = (revealed) => {
    root.dispatchEvent(
      new CustomEvent('heroMbp:reveal', {
        detail: { revealed },
      }),
    )
  }

  const update = () => {
    const max = getMaxScroll()
    let x = scroller.scrollLeft
    if (x > max) {
      scroller.scrollLeft = max
      x = max
    }
    const mbpUnlocked = max <= 0 || x >= HERO_MBP_REVEAL_PX
    root.classList.toggle('hero-studio--mbp-locked', !mbpUnlocked && max > 0)
    dispatchMbp(mbpUnlocked)

    root.querySelectorAll('[data-hero-scroll-hide-at-max]').forEach((el) => {
      if (max <= 0) {
        el.style.opacity = '1'
        el.style.pointerEvents = 'auto'
        return
      }
      // Иначе при max < HIDE_LOOK_PX выражение x >= max - 250 всегда true при x = 0 — кнопка «Посмотреть» пропадала
      const hideNearEnd = max > HIDE_LOOK_PX ? x >= max - HIDE_LOOK_PX : x >= max
      if (hideNearEnd) {
        el.style.opacity = '0'
        el.style.pointerEvents = 'none'
      } else {
        el.style.opacity = '1'
        el.style.pointerEvents = 'auto'
      }
    })

    root.querySelectorAll('[data-hero-scroll="start"]').forEach((el) => {
      if (x <= SHOW_BACK_PX) {
        el.style.opacity = '0'
        el.style.pointerEvents = 'none'
      } else {
        el.style.opacity = '1'
        el.style.pointerEvents = 'auto'
      }
    })
  }

  const bind = () => {
    abort.abort()
    abort = new AbortController()
    const { signal } = abort

    scroller.addEventListener('scroll', update, { passive: true, signal })

    root.querySelectorAll('[data-hero-scroll="end"]').forEach((btn) => {
      btn.addEventListener(
        'click',
        (e) => {
          e.preventDefault()
          const m = getMaxScroll()
          scroller.scrollTo({ left: m, behavior: 'smooth' })
        },
        { signal },
      )
    })

    root.querySelectorAll('[data-hero-scroll="start"]').forEach((btn) => {
      btn.addEventListener(
        'click',
        (e) => {
          e.preventDefault()
          scroller.scrollTo({ left: 0, behavior: 'smooth' })
        },
        { signal },
      )
    })

    update()
  }

  const onChange = () => {
    if (mq.matches) {
      bind()
    } else {
      abort.abort()
      clearInlines()
      root.classList.remove('hero-studio--mbp-locked')
      dispatchMbp(true)
    }
  }

  mq.addEventListener('change', onChange)
  onChange()
}
